// ブラウザから GA4 / Google 広告へ購入通知を送る入口。
declare global {
  interface Window {
    dataLayer?: Record<string, unknown>[];
    gtag?: (
      command: "event",
      event: "conversion",
      params: Record<string, unknown>,
    ) => void;
  }
}

/**
 * GTM のカスタムイベントを送る
 */
export const pushDataLayerEvent = (
  event: string,
  params: Record<string, unknown> = {},
): void => {
  window.dataLayer?.push({ event, ...params });
};

/**
 * 既存の Google タグへ買い切り購入を送る。
 * backend と同じアクション・取引 ID を使い、タグと API の重複を排除する。
 * Google タグ AW-11105851262 は本番の GTM で設定済み。
 */
export const reportGoogleAdsPurchase = (
  transactionId: string,
  value: number,
  currency: string,
): void => {
  // dev / local のテスト決済を本番の広告実績に混ぜない。
  if (
    process.env.REACT_APP_READABLE_PRODUCT !== "True" ||
    window.location.origin !== "https://readzh.com"
  ) {
    return;
  }

  window.gtag?.("event", "conversion", {
    send_to: "AW-11105851262/yi3kCLShh74cEP6u168p",
    transaction_id: transactionId,
    value,
    currency,
  });
};

/**
 * 購入プラン -> GTM のカスタムイベント名
 *
 * このカスタムイベントは GA4 用。Google 広告へは reportGoogleAdsPurchase と
 * backend の Data Manager API から、同じ取引 ID で送る。
 *
 * プランを増やすときは GTM 側にトリガーと GA4 タグを作ってからここに足すこと。
 */
const PURCHASE_EVENT_NAMES: Record<string, string> = {
  annual: "purchaseannual",
};

/**
 * 購入プランに対応する GTM のイベント名を返す
 *
 * 対応が無いプランは黙って送らずに例外にする。
 * 気付かないまま GA4 の購入が欠けるより、エラーで止まる方がよい。
 */
export const getPurchaseEventName = (plan: string): string => {
  const eventName = PURCHASE_EVENT_NAMES[plan];
  if (!eventName) {
    throw new Error(`No GTM purchase event is defined for plan '${plan}'`);
  }

  return eventName;
};
